<template>
  <div>
    <table class="ui very compact center aligned celled table" v-if="reservations.length">
      <thead>
        <tr> 
          <th>Reservation id</th>
          <th>Visit id</th>
          <th>Clinic</th>
          <th>Time</th>
          <th>Doctor</th>
          <th>Package</th>
          <th>Used quantity</th>
        </tr>
      </thead>
        <tbody v-for="reservationId in Object.keys(computedReservaitonVisits)" :key="reservationId">
          <template v-for="(reservationVisitId, visitIndex) in Object.keys(computedReservaitonVisits[reservationId].visits)">
            <tr 
              v-for="(visitDetail, index) in computedReservaitonVisits[reservationId].visits[reservationVisitId].visitDetails"
              :key="index + ' ' + visitDetail.quantity + ''+ getReservationsRowSpan(reservationId)"
            >
              <td 
                :rowspan="getReservationsRowSpan(reservationId)" 
                v-if="visitIndex === 0 && index === 0"
              > 
                <a class="id-link" @click="goToReservation(reservationId)">
                  {{ reservationId }}
                </a> 
              </td>
              <td 
                style="border-left: 1px solid rgba(34,36,38,.1)"
                :rowspan="computedReservaitonVisits[reservationId].visits[reservationVisitId].visitDetails.length"
                v-if="index === 0" 
              > 
                <a class="id-link" @click="goToReservationVisit(reservationVisitId)">
                  {{ reservationVisitId }}
                </a>
              </td>
              <td 
                style="border-left: 1px solid rgba(34,36,38,.1)"
                :rowspan="computedReservaitonVisits[reservationId].visits[reservationVisitId].visitDetails.length"
                v-if="index === 0" 
              > 
                {{ computedReservaitonVisits[reservationId].visits[reservationVisitId].clinic }}
              </td>
              <td 
                style="border-left: 1px solid rgba(34,36,38,.1)"
                :rowspan="computedReservaitonVisits[reservationId].visits[reservationVisitId].visitDetails.length"
                v-if="index === 0" 
              > 
                {{ computedReservaitonVisits[reservationId].visits[reservationVisitId].time }}
              </td>
              <td v-if="index === 0"  :rowspan="computedReservaitonVisits[reservationId].visits[reservationVisitId].visitDetails.length"> 
                {{ computedReservaitonVisits[reservationId].visits[reservationVisitId].doctor || '-' }} 
              </td>
              <td style="border-left: 1px solid rgba(34,36,38,.1)"> {{ visitDetail.packageName }} </td>
              <td> {{ visitDetail.quantity }} </td>
            </tr>
          </template>
        </tbody>
    </table>
    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No Reservations have been made yet
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    reservations: { type: Array, required: true },
    visits: { type: Array, required: true }
  },
  data() {
    return {
      tabs: {
        first: 'available',
        second: 'completed'
      },
      currentTab: 'available',
      packagesById: {},
      reservationVisits: []
    }
  },
  computed: {
    packagesColumns () {
      return [
        { header: 'Name', fieldName: 'name', show: true, width: '15%' },
        { header: 'Description', fieldName: 'description', show: true },
        { header: 'Unit Price', fieldName: 'unitPrice', show: true, classes: 'positive' },
        { header: 'Quantity', fieldName: 'quantity', show: true },
        { header: 'Package Price', fieldName: 'packagePrice', show: true, classes: 'positive' },
        { header: 'Repeated', fieldName: 'repeated', show: true },
        { header: 'Total Price', fieldName: 'totalPrice', show: true, classes: 'positive' },
        { header: 'Remainder Quantity', fieldName: 'remainder', show: true }
      ]
    },
    computedReservaitonVisits () {
      let formlateVisits = {}
      const filteredReservations = this.reservations.filter(r => !r.cancelled_at)     
      this.packagesById = 
        filteredReservations
          .flatMap(r => r.reservations_packages)
          .reduce((obj, rp) => ({...obj, [rp.package.id]: rp.package}), {})
      
      const visitsByReservaitonId = window._.groupBy(this.visits, 'reservation_id')

      this.reservationVisits = filteredReservations.flatMap(r => r.reservation_visits)

      window._.each(filteredReservations, reservation => {
        const visits = visitsByReservaitonId[reservation.id]
        formlateVisits[reservation.id] = {
          visits: this.computedVisits(visits)
        }
      })

      return formlateVisits
    },
  },
  methods: {
    getReservationsRowSpan(reservationId) {
      const visits = Object.values(this.computedReservaitonVisits[reservationId].visits)
      return window._.sumBy(visits, visit => visit.visitDetails.length)
    },
    computedVisits(visits) {
      let formalteVisits = {}
      const notCancelledVisits = visits.filter (visit => visit.visit_status_id != this.VisitStatuses.CANCELLED)
      window._.each(notCancelledVisits, visit => {
        const reservationVisitId = this.getReservationVisitId(visit).id

        formalteVisits[reservationVisitId] = {
          doctor: visit.doctor ? visit.doctor.name : '-',
          time: this.timeFormat(visit.started_at || visit.time),
          clinic: this.clinics.find(visit.clinic_id).name,
          visitDetails: this.computedVisitDetails(visit)
        }
      })

      return formalteVisits
    },
    computedVisitDetails(visit) {
      let formalteVisitDetails = []
      window._.each(visit.visit_details, visitDetail => {
        const selectedPackage = this.packagesById[visitDetail.package_id]

        formalteVisitDetails.push({
          packageName: selectedPackage.name,
          quantity: visitDetail.quantity,
        })
      })

      return formalteVisitDetails
    },
    getReservationVisitId (visit) {
      return this.reservationVisits.find(rv => {
        return rv.reservation_id === visit.reservation_id 
          && rv.visit_id === visit.id 
          && rv.clinic_id === visit.clinic_id
      })
    },
    goToReservation(reservationId) {
      this.navigateTo(`Show_Reservation`, {
        key: 'params',
        value: { id: reservationId }
      })
    },
    goToReservationVisit(reservationVisitId) {
      this.navigateTo(`Show_Visit`, {
        key: 'params',
        value: { reservationVisitId: reservationVisitId }
      })
    },
    timeFormat (time) {
      return window.moment(time).format('LLLL')
    }
  },
}
</script>

<style scoped>
  .id-link {
    cursor: pointer; 
    text-decoration:underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/applications_components/Visits.vue